<style>
.img-fluid{
cursor: pointer;
}

.centered-link{
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  font-size: 0.9em;
  text-align: center;
}

.slick-slider[data-v-3d1a4f76] {
width: 60%;

}

.col-lg-7 {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.slick-slide img[data-v-e4caeaf8] {
    display: block;
}
.data-v-e4caeaf8{
  width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.slick-arrow {
  font-size: 24px;
  color: #333;
  z-index: 10;
  border: none;
  background: transparent;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.slick-arrow:hover {
color: #045C68;

}

.slick-prev {
  font-size: 3em;
  left: -30px;
}

.slick-next {

  font-size: 3em;
  right: -30px;
}
</style>

<template>
  <div id="lactationedn-view">
    <head>
      <meta name="description" content="ResMed Masks">
    </head>
    <section class="bg-light ftco-section">
      <div class="container" style="min-width: 90vw;">
        <h1 class="display-4 text-center  my-4">RESMED CPAP MASKS<br>
        <Span style="font-size: 0.3em;">(prescription required)</Span>
        </h1>
        <div class="row  my-5">
          <div class="col-md-12 col-lg-7">
            <VueSlickCarousel 
            ref="mainSlider"
            :arrows="true" 
            :fade="true" 
            :as-nav-for="$refs.thumbnailSlider"
            >
        <div v-for="image in images" :key="image.id">
          <img :src="image.src" :alt="image.alt" class="img-fluid" />
        </div>
        <template v-slot:prevArrow>
        <button class="slick-arrow slick-prev">
          <i class="fas fa-chevron-left"></i>
        </button>
      </template>
      <template v-slot:nextArrow>
        <button class="slick-arrow slick-next">
          <i class="fas fa-chevron-right"></i>
        </button>
      </template>
      </VueSlickCarousel>
      <VueSlickCarousel
        :slides-to-show="5"
        :focus-on-select="true"
        :as-nav-for="$refs.mainSlider"
        class="mt-2"
      >
        <div v-for="image in images" :key="image.id">
          <img :src="image.thumbnail" :alt="image.alt" class="img-fluid" />
        </div>
      </VueSlickCarousel>
          </div>
          <div class="col-md-12 col-lg-5">
            <h3 class="mt-5 mb-2 text-light1">Airtouch N20 Nasal Mask </h3>
            <div class="row mb-4">
              <div class="col">
                <span class="text3">Description</span>
              </div>
            </div>
            <p>
                The ResMed AirTouch™ mask series is where comfort meets convenience. Its UltraSoft™ memory foam cushion delivers a uniquely comfortable experience and doesn’t require cleaning when replaced regularly, making your morning routine that much easier!



            </p>
            <div class="row mb-4">
              <div class="col">
              </div>
            </div>
            
              <div id="action-buttons" class="d-flex justify-content-between">
    <router-link to="/cpapform" class="btn btn-light mt-3" style="white-space: normal; font-size: 13px !important;" tag="button">
      Purchase with insurance
    </router-link>
  </div>

          </div>
        </div>
        <div class="row my-5">
  <div class="col-md-6">
    <h3 class="mt-5 mb-2 text-light1">Features</h3>
    <ul>
      <li>
        UltraSoft memory foam cushion is uniquely comfortable
      </li>
      <li>
        Magnetic clips mean two simple snaps and your mask is on or off
      </li>
      <li>
        Quick-release elbow allows you to get up at night and disconnect without removing the mask
      </li>
      <li>
        Minimal cleaning requirements give you time back in the morning
      </li>
      <li>
        Available in a for Her version, which features lavender accents rather than blue, and is only available in size Small
      </li>
      <li>
        The mask frame is designed to also work with the ResMed AirFit™ N20 silicone cushion
      </li>
    </ul>
  </div>
  <div class="col-md-6">
    <h3 class="mt-5 mb-2 text-light1"></h3>
    <ul>
    </ul>
  </div>
</div>
      </div>      
    </section>
  </div> 
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default {
  components: {
    VueSlickCarousel,
  },
  data() {
  return {
    images: [
    { id: 1, src: require('@/assets/site/CPAP/AirtouchN20NasalMask/1.jpg'), thumbnail: require('@/assets/site/CPAP/AirtouchN20NasalMask/1.jpg'), alt: 'Image 1' },
    { id: 2, src: require('@/assets/site/CPAP/AirtouchN20NasalMask/2.jpg'), thumbnail: require('@/assets/site/CPAP/AirtouchN20NasalMask/2.jpg'), alt: 'Image 2' },
    { id: 3, src: require('@/assets/site/CPAP/AirtouchN20NasalMask/3.jpg'), thumbnail: require('@/assets/site/CPAP/AirtouchN20NasalMask/3.jpg'), alt: 'Image 3' },
    // { id: 4, src: require('@/assets/site/CPAP/AirFitN30iNasalMask/4.webp'), thumbnail: require('@/assets/site/CPAP/AirFitN30iNasalMask/4.webp'), alt: 'Image 4' },
    // { id: 5, src: require('@/assets/site/CPAP/AirFitN30iNasalMask/5.webp'), thumbnail: require('@/assets/site/CPAP/AirFitN30iNasalMask/5.webp'), alt: 'Image 5' },
    // { id: 6, src: require('@/assets/site/CPAP/AirFitN30iNasalMask/6.webp'), thumbnail: require('@/assets/site/CPAP/AirFitN30iNasalMask/6.webp'), alt: 'Image 6' },
      // ... more images
    ],
  }
},
mounted() {
  this.$nextTick(() => {
    const arrows = this.$el.querySelectorAll('.slick-arrow');
    arrows.forEach(arrow => {
      arrow.addEventListener('click', () => {
        arrow.blur();
      });
    });
  });
}

}
</script>
